import React from 'react';
import {
    Content,
    ContentVariants,
    Card,
    CardTitle,
    CardBody,
    CardFooter,
    Grid,
    GridItem
} from '@patternfly/react-core';
import Panel from './Panel';
import { techStackData } from '../hooks/data';

const TechStack = () => {
    return (
        <Card>
            <CardTitle>
                <Content style={{ textAlign: 'center' }} component={ContentVariants.h1}>Stos technologiczny</Content>
                <Content style={{ textAlign: 'center' }} component={ContentVariants.p}>
                    Z naszej serwerowni udostępniamy nowoczesne środowisko laboratoryjne oparte <br />na technologiach klasy enterprise, działających na poziomie klastra i wykorzystywanych w centrach danych oraz chmurach prywatnych i publicznych.
                </Content>
            </CardTitle>
            <CardBody>
                <Grid hasGutter>
                    {techStackData.map((item, index) => (
                        <GridItem
                            key={index}
                            sm={12}
                            md={6}
                            lg={6}
                            xl={3}
                            xl2={3}
                        >
                            <Panel data={item} />
                        </GridItem>
                    ))}
                </Grid>
            </CardBody>
            <CardFooter>
            </CardFooter>
        </Card>
    );
};

export default TechStack;